<template lang="pug">
  button.ui-tooltip(
    tabindex="-1"
    type="button"
    ref="tooltip"
    :class="tooltipClasses"
  ): ui-icon(icon="ui-tooltip")
</template>

<script>
import tippy from 'tippy.js'

export default {
  name: 'UiTooltip',

  // Props ---------------------------------------------------------------------
  props: {

    // Tooltip text
    content: {
      type: String,
      default: 'Tooltip text'
    },

    // Tooltip style
    theme: {
      type: String,
      default: 'dark',
      validator (value) {
        return ['light', 'dark'].indexOf(value) !== -1
      }
    }
  },

  // Mounted -------------------------------------------------------------------
  mounted () {
    this.tippyInit() // Init tippy first time
  },

  // Before destroy ------------------------------------------------------------
  beforeDestroy () {
    this.tippyDestroy() // Destroy tippy
  },

  // Watch ---------------------------------------------------------------------
  watch: {
    content (fresh) {
      this.tippyUpdate(fresh)
    }
  },

  // Computed ------------------------------------------------------------------
  computed: {

    // Prefixed class
    prefixedClass () {
      return 'ui-tooltip-' + this.theme
    },

    // Tooltip classes
    tooltipClasses () {
      return [
        this.prefixedClass
      ]
    }
  },

  // Methods -------------------------------------------------------------------
  methods: {

    // Initialization
    tippyInit () {
      tippy(this.$refs.tooltip, {
        content: this.content, // Default text on init
        appendTo: this.$root.$children[0].$refs.mountPoint, // Element to append
        arrow: true,
        animateFill: false,
        placement: 'top-end',
        performance: true,
        interactive: true,
        theme: 'light',
        zIndex: 80
      })
    },

    // Update content
    tippyUpdate (fresh) {
      this.$refs.tooltip._tippy.setContent(fresh)
    },

    // Destroy
    tippyDestroy () {
      this.$refs.tooltip._tippy.destroy()
    }
  }
}
</script>
